@import 'igws-cta.less';

:host {
  --cta-link-transform: rotate(180deg);
  --cta-link-text-margin: 0 5px 0 0;
}

.cta-wrapper.secondary-download {
  padding: 8px 0 8px 20px;
}

.cta-wrapper {
  .suffix-wrapper {
    transform: scaleX(-1);
  }
  &.information {
    .suffix-wrapper {
      margin-right: auto;
      margin-left: 0;
    }
  }
}
